// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"50":"ae61944cd0f44506","440":"9a2646545a479368","581":"7a276989b6da6a7a","695":"a70c75f01464b472"}[chunkId] + ".js";
};